import type { ComponentProps } from 'react';

import { Input as ShadcnInput } from '@/lib/shadcn/input';

export function Input({ ...props }: ComponentProps<typeof ShadcnInput>) {
  return <ShadcnInput {...props} />;
}
